import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter } from 'eurogard-open-api-remote-method';
import { ProxyRemoteMethod } from 'eurogard-remote-method';
import { Inject, Injectable, InjectFlags, Injector, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RXAP_FORM_CONTEXT, RXAP_FORM_INITIAL_STATE } from 'eurogard-forms';

/**
 * @deprecated replace by the SubmitEditFormAdapter and the new service concept
 */
@Injectable()
export class CreateSubmitFormWithUuidAdapter extends ProxyRemoteMethod<any, Record<string, any>, OpenApiRemoteMethodParameter> {

  constructor(
    @Inject(OpenApiRemoteMethod)
      remoteMethod: OpenApiRemoteMethod,
    @Optional()
    @Inject(RXAP_FORM_CONTEXT)
    private readonly context: { uuid?: string, rowId?: string } | null,
    @Optional()
    private readonly route: ActivatedRoute | null,
  ) {
    super(remoteMethod);
  }

  public transformParameters(value: Record<string, any>): OpenApiRemoteMethodParameter {
    const uuid = this.context?.uuid ?? this.context?.rowId ?? this.route?.snapshot.paramMap.get('uuid');
    if (!uuid) {
      throw new Error('Could not extract the edit submit uuid');
    }
    return {
      parameters: {uuid},
      requestBody: value,
    };
  }

}

export function CreateSubmitFormWithUuidAdapterFactory(
  remoteMethod: OpenApiRemoteMethod,
  context: { uuid: string } | null,
  injector: Injector,
) {
  return new CreateSubmitFormWithUuidAdapter(
    remoteMethod,
    context ?? injector.get<any>(RXAP_FORM_INITIAL_STATE, null, InjectFlags.Optional) ?? null,
    injector.get(ActivatedRoute, null, InjectFlags.Optional),
  );
}
